import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import IconComponent from '../../../portal/iconComponent';
import { Button, ButtonType } from '@checkmarx/cx-ui';
import { Panel } from 'react-bootstrap';
import styles from '../style.scss';

@inject('translationsStore', 'twoFAStore') @observer

export default class RecoveryCodes extends Component {
    componentDidMount() {
        this.props.twoFAStore.getRecoveryCodes().then((response) => {
            this.props.twoFAStore.recoveryCodes = response;
        });
    }

    render() {
        const { recoveryCodes, currentStep, recoveryCodesMessage, twoFactorSteps } = this.props.twoFAStore;
        
        return (
            <div>
                <div className={'form-notification-message-wrapper show'}>
                    <span className="sucess-message" >
                        <IconComponent iconClassName="alert-success-icon" /> {recoveryCodesMessage}
                    </span>
                </div>
                <div className="title" style={{ paddingBottom: '10px' }}>{this.props.translationsStore.translate('RECOVERY_CODES')}</div>
                <Panel className='infoPanel'>
                    <b>{this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE1')}</b><br /><br />
                    {this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE2')}
                </Panel>
                <div>
                    <ul>
                        {this.props.twoFAStore.recoveryCodes.map((value, index) => {
                            return <li key={index}>{value}</li>
                        })}
                    </ul>
                </div>
                <div>
                    <Button
                        onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.authoptions)}
                        text={this.props.translationsStore.translate('BACK')}
                        type='button'
                    >
                    </Button>
                </div>
            </div>)
    }
}